var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeePage',[_c('ContentLoading',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"card p-4"},[_c('EmployeeSettingsForm',{on:{"saved":_vm.handleSaved}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }